import angular from 'angular';

import PlanSubscriptionComponent from './plan-subscription.cmpt';

export default angular
    .module('common.plans.component.plan-subscription', [])
    .component(PlanSubscriptionComponent.selector, PlanSubscriptionComponent);



// WEBPACK FOOTER //
// ./src/common/component/plans/component/plan/component/plan-subscription/index.js